export let darkColors = {
	background: {
		main: "#101826",
	},
	secondary: {
		main: "#12B76A",
	},
	icon1: {
		main: "#F79009",
	},
	background2: {
		main: "#0A0F18",
	},
	background3: {
		main: "#101828",
	},
	stroke: {
		main: "#1D2939",
	},
	primary: {
		main: "#FFFFFF",
	},
	flows: {
		main: "#98A2B3",
	},
	desc: {
		main: "#97A1BA",
	},
	ticks: {
		main: "#10B981",
	},
	tags: {
		main: "#98a2b31f",
	},
};

export let lightColors = {
	background: {
		main: "#FFFFFF",
	},
	secondary: {
		main: "#12B76A",
	},
	background2: {
		main: "#fcfcfd",
	},
	background3: {
		main: "#fcfcfd",
	},
	primary: {
		main: "#000000",
	},
	flows: {
		main: "#DDDFE1",
	},
	desc: {
		main: "#667085",
	},
	icon1: {
		main: "#F79009",
	},
	ticks: {
		main: "#10B981",
	},
	stroke: {
		main: "#10182861",
	},
	tags: {
		main: "#1018281f",
	},
};
